import { PATHS } from "@/internals/constants/paths";

import { QREditorLayoutTemplateStepperButtonDataProps } from "@/templates/QrEditorTemplates/qr-layout/types";

export const QR_EDITOR_STEPPER_BUTTONS: QREditorLayoutTemplateStepperButtonDataProps[] = [
  {
    label: "stepper_button_select_qr_lLabel",
    dataQA: "stepper-select-qr-type-button",
    slug: PATHS.QR_EDITOR,
  },
  {
    label: "stepper_button_content_label",
    dataQA: "stepper-add-content-button",
    slug: `${PATHS.QR_EDITOR}/business`,
  },
  {
    label: "stepper_button_design_label",
    dataQA: "stepper-customize-design-button",
    slug: `${PATHS.QR_EDITOR}/business${PATHS.DESIGN}`,
  },
];

export const initialStepperButtons = (
  stepperButtonsData: QREditorLayoutTemplateStepperButtonDataProps[] = QR_EDITOR_STEPPER_BUTTONS
) => {
  return stepperButtonsData.map((stepperButton) => ({
    label: stepperButton.label,
    dataQA: stepperButton.dataQA,
    disabled: false,
  }));
};
